import { ElLoading } from 'element-plus'

export function downExcel(res, fileName) {
    var blob = new Blob([res.data], {
        type: 'application/octet-stream;charset=UTF-8',
    })
    var downloadElement = document.createElement('a');
    var href = window.URL.createObjectURL(blob);
    downloadElement.style.display = 'none';
    downloadElement.href = href;
    downloadElement.download = decodeURI(fileName + '.xlsx');
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement);
    window.URL.revokeObjectURL(href);
}

export function loading(tipText) {
    var loading = ElLoading.service({
        lock: true,
        text: tipText,
        background: "rgba(0, 0, 0, 0.7)",
    });
    return loading;
}

//选择学校后加载学校对应的年级
export function schoolChage(schoolList, gradeList, schoolId) {
    //通过学校Id找到对应的学校信息
    var schoolObj = schoolList.filter((item) => {
        return item.id == schoolId;
    });
    //拿到学校的schoolType与年级gradeList集合中的schoolType的匹配
    //得到对应学校类型下的年级
    var _gradeList = gradeList.filter((item) => {
        return item.schoolType == schoolObj[0].schoolType;
    });
    //按一二十三四五六给对象中添加排序字段orderIndex
    if (_gradeList != null && _gradeList.length > 0) {
        _gradeList.forEach((m) => {
            if (m.name.indexOf("一") > -1) m.orderIndex = 1;
            else if (m.name.indexOf("二") > -1) m.orderIndex = 2;
            else if (m.name.indexOf("三") > -1) m.orderIndex = 3;
            else if (m.name.indexOf("四") > -1) m.orderIndex = 4;
            else if (m.name.indexOf("五") > -1) m.orderIndex = 5;
            else m.orderIndex = 6;
        });
        //排序
        _gradeList = _gradeList.sort(function (a, b) {
            return a.orderIndex < b.orderIndex
                ? -1
                : a.orderIndex > b.orderIndex
                    ? 1
                    : 0;
        });
    }
    return _gradeList;
};

//将el-uplod上传的图片转为base64
export function getBase64(file) {
    return new Promise(function (resolve, reject) {
        let reader = new FileReader();
        let imgResult = "";
        reader.readAsDataURL(file);
        reader.onload = function () {
            imgResult = reader.result;
        };
        reader.onerror = function (error) {
            reject(error);
        };
        reader.onloadend = function () {
            resolve(imgResult);
        };
    });
}

//检查是否是移动端还是PC,True为移动端
export function checkMobileOrPc(){
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // 检测移动设备
    return /android|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(userAgent);
}